export default defineAppConfig({
  nuxtIcon: {
    size: "20px", // default <Icon> size applied
  },
});
